import {getSkills} from '../../utils/sanity/sanity';

async function GetSkills(){

  const skillsData = await getSkills();
  return skillsData;

}

export default GetSkills;